module.exports = __webpack_public_path__ + "static/img/XMSH04.5636fb8d.jpg";